import React from 'react';

import {
    CheckboxGroupInput,
    ArrayInput,
    SimpleFormIterator,
    FunctionField,
    FormDataConsumer
} from 'react-admin';
import Box from "@material-ui/core/Box";
import {Typography} from "@material-ui/core";
import { useForm, useFormState } from 'react-final-form';

const DivisionMedicalProgramInput = props => {
    const contractNumber = record => record.contractNumber;
    // const { values } = useFormState();
    const form = useForm();

    const inArray = (needle, haystack)  => {
        let length = haystack.length;
        for(let i = 0; i < length; i++) {
            if(haystack[i] === needle) return true;
        }
        return false;
    }

    const changeMedicalProgram = () => {
        // let values = form.getState().values;
        // // return;
        // //props.checkContract(true);
        //
        // for (let i = 0; i < values.contracts.length; i++) {
        //     let medicalPrograms = values.contracts[i].medicalPrograms;
        //     let selectedPrograms = values.contracts[i].programs;
        //     let count = 0;
        //
        //     for (let j = 0; j < medicalPrograms.length; j++) {
        //         if (medicalPrograms[j].selected) {
        //             if (!inArray(medicalPrograms[j].id, selectedPrograms)) {
        //                 props.checkContract(true);
        //                 return;
        //             }
        //             count++;
        //         }
        //     }
        //
        //     if (selectedPrograms.length !== count) {
        //         props.checkContract(true);
        //         return;
        //     }
        // }

        props.checkContract(true);
    };

    return (
        props.record?.contracts?.length === 0
            ? <div>
                <Box textAlign="center" m={1}>
                    <Typography variant="h6" paragraph>
                        Нема активних контрактів.
                    </Typography>
                </Box>
            </div>
            : props.record?.dlsVerified === false
                ? <div>
                    <Box textAlign="center" m={1}>
                        <Typography variant="h6" paragraph>
                            Аптека неактивна. Для керування мед. програмами активуйте аптеку.
                        </Typography>
                    </Box>
                </div>
                : props.record?.status === 'INACTIVE'
                    ? <div>
                        <Box textAlign="center" m={1}>
                            <Typography variant="h6" paragraph>
                                Аптека неактивна. Для керування мед. програмами активуйте аптеку.
                            </Typography>
                        </Box>
                    </div>
                    : <ArrayInput {...props}>
                        <SimpleFormIterator disableRemove={true} disableAdd={true}>
                            <FunctionField label="Контракт" render={contractNumber} />
                            <FormDataConsumer>
                                {({ getSource, scopedFormData }) => {
                                    return (
                                        <CheckboxGroupInput
                                            label="Програми"
                                            source={getSource('programs')}
                                            row={false}
                                            choices={scopedFormData?.medicalPrograms || []}
                                            onChange={changeMedicalProgram}
                                        />
                                    );
                                }}
                            </FormDataConsumer>
                        </SimpleFormIterator>
                    </ArrayInput>
    );
}

export default DivisionMedicalProgramInput;
